export default __webpack_public_path__ + "static/media/Harness of the Savage Slaughter.4d6ed595.jpg";